import { Box, ButtonBase, SxProps, Theme } from "@mui/material";
import React from "react";
import { OverlayView } from "@react-google-maps/api";
import LazyImage from "components/LazyImage";
import { colors, drjInfo, initialZoom, pcWorthLatLng } from "common";
import { H6, Small } from "components/Typography";

// ==============================================================
type Props = {
  mapRef?: google.maps.Map;
};
// ==============================================================

const PCWorthMapOverlay = ({ mapRef }: Props) => {
  const onGoToPCWorth = () => {
    if (mapRef) {
      mapRef?.panTo(pcWorthLatLng);
      mapRef?.setZoom(initialZoom);
    }
  };

  return (
    <OverlayView
      position={pcWorthLatLng}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <Box>
        <ButtonBase onClick={onGoToPCWorth}>
          <LazyImage
            width={80}
            height={80}
            objectFit="contain"
            objectPosition="center"
            src={"/assets/images/kachi/kachi-motor.png"}
          />
          {/* <Box>
            <H6>PC Worth</H6>
            <Small>{drjInfo?.location}</Small>
          </Box> */}
        </ButtonBase>
      </Box>
    </OverlayView>
  );
};

export default PCWorthMapOverlay;
